/**
 * Some constants that can be used inside the heizcheck advisor.
 */
export class HeizcheckConstants {
  // maximum tim e in days until a local storage element of the advisor should be valid
  static readonly LOCALSTORAGE_TIMEOUT_DAYS = 2;

  static readonly FLAT_PEOPLE_MAX = 10;

  // min/max sizes for apartements
  static readonly FLAT_AREA_MIN = 10;
  static readonly FLAT_AREA_MAX = 400;
  static readonly FLAT_AREA_AVERAGE = 80;

  //form inputs
  static readonly INVOICE_MIN_DAYS = 270;
  static readonly INVOICE_MAX_DAYS = 450;
  static readonly INVOICE_MIN_DAYS_IN_PAST = 1;

  // co2 calculation
  static readonly CO2_PRICE = {2020: 0, 2021: 25, 2022: 30, 2023: 35, 2024: 40, 2025: 55};
  static readonly CO2_TREE_KG_YEAR = 12.5;

  // range for old buildings
  static readonly OLD_BUILDING_MAXYEAR = 1978;

  // some websocket strings
  static readonly WEBSOCKET_SENDER_DESKTOP = 'desktop';
  static readonly WEBSOCKET_SENDER_MOBILE = 'mobile';
  static readonly WEBSOCKET_MESSAGE_REGISTER = 'register';
  static readonly WEBSOCKET_MESSAGE_CONNECTION_LOST = 'connection_lost';
  static readonly WEBSOCKET_MESSAGE_IMAGEUDPATE = 'imageupdate';
  static readonly WEBSOCKET_MESSAGE_STARTCAMERA = 'startcamera';
  static readonly WEBSOCKET_MESSAGE_STOPCAMERA = 'stopcamera';
  static readonly WEBSOCKET_MESSAGE_UPLOADFINISHED = 'uploadfinished';
  static readonly WEBSOCKET_MESSAGE_MSP_SELECTED = 'mspselected';
  static readonly WEBSOCKET_MESSAGE_UPLOADSTARTED = 'uploadstarted';
  static readonly WEBSOCKET_MESSAGE_KI_START = 'kistart';
  static readonly WEBSOCKET_MESSAGE_KI_SUCCESS = 'kisuccess';
  static readonly WEBSOCKET_MESSAGE_KI_ERROR = 'kierror';

  // some detection settings
  static readonly DETECTION_MIN_VALUECOUNT = 3;

  // snackbar
  static readonly SNACKBAR_DURATION_DEFAULT = 5000;
  static readonly SNACKBAR_POSITION_VERTICAL = 'top';

  // min max values of each apartment size in a apartment building
  static readonly APARTMENT_SIZE_MIN = 20;
  static readonly APARTMENT_SIZE_MAX = 250;
}
